<div class="smart-form">
    <app-color-input [value]="colors[0] || ''" #colorString1 [lineNumber]=1></app-color-input>
    <app-color-input [value]="colors[1] || ''" #colorString2 [lineNumber]=2></app-color-input>
    <app-color-input [value]="colors[2] || ''" #colorString3 [lineNumber]=3></app-color-input>

    <div class="actions justify-content-evenly">
        <div *ngIf="!colors.length" class="form-button" (click)="cancel.emit()">Cancel</div>
        <div *ngIf="colors.length" class="form-button" (click)="deleteColor.emit(index)">Delete</div>
        <div class="form-button"
            (click)="submitForm.emit([colorString1.value, colorString2.value, colorString3.value])">
            Save
        </div>
    </div>
</div>